<template>
  <div class="user__forgetPassword">
    <span>
      {{ $t("user.forgotPassword") }}
    </span>
    <b-field
      :label="$t('email.name')"
      :type="{ 'is-danger': errors.has('email') }"
      :message="errors.first('email')"
    >
      <b-input
        type="email"
        v-model="email"
        name="email"
        v-validate="'required'"
      />
    </b-field>
    <button
      @click="sendForgotPassword"
      class="button is-success is-rounded action-button"
      icon-left="plus"
    >
      {{ $t("send") }}
    </button>
    <b-button
      @click="$emit('cancel')"
      class="button is-danger is-rounded action-button"
      icon-left="close"
    >
      {{ $t("close") }}
    </b-button>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "forgotPassword",
  data: () => {
    return {
      email: ""
    };
  },
  methods: {
    ...mapActions(["forgotPassword"]),
    sendForgotPassword() {
      this.$emit("close");
      this.forgotPassword({ email: this.email, lang: this.$i18n.locale }).then(
        message => {
          this.$buefy.toast.open({
            message: this.$t(message),
            type: "is-info",
            duration: 6000,
            position: "is-top-right"
          });
        }
      );
    }
  }
};
</script>
